// frontend/src/components/Dashboard.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      {/* Navbar */}
      <nav style={styles.navbar}>
        <div style={styles.navBrand}>
          <span style={styles.navLogo}>📻</span>
          <span style={styles.navTitle}>RadioCharts</span>
        </div>
        <div style={styles.navUser}>
          <span style={styles.userName}>{user?.full_name || user?.username}</span>
          <button onClick={handleLogout} style={styles.logoutBtn}>
            Cerrar Sesión
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <main style={styles.main}>
        <div style={styles.welcomeCard}>
          <div style={styles.welcomeIcon}>🎵</div>
          <h1 style={styles.welcomeTitle}>
            Bienvenido a RadioCharts
          </h1>
          <p style={styles.welcomeSubtitle}>
            Plataforma de Charts Musicales Hispanoamérica
          </p>
          <div style={styles.badge}>v0.1.0</div>
        </div>
      </main>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f0f2f5',
  },
  navbar: {
    background: 'linear-gradient(135deg, #1a1a2e, #0f3460)',
    padding: '0 32px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  },
  navBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  navLogo: {
    fontSize: '24px',
  },
  navTitle: {
    color: 'white',
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '0.5px',
  },
  navUser: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  userName: {
    color: '#a0aec0',
    fontSize: '14px',
  },
  logoutBtn: {
    background: 'rgba(255,255,255,0.1)',
    color: 'white',
    border: '1px solid rgba(255,255,255,0.2)',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background 0.2s',
  },
  main: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 64px)',
    padding: '32px',
  },
  welcomeCard: {
    background: 'white',
    borderRadius: '20px',
    padding: '64px 80px',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    maxWidth: '600px',
    width: '100%',
  },
  welcomeIcon: {
    fontSize: '64px',
    marginBottom: '24px',
  },
  welcomeTitle: {
    fontSize: '36px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 12px 0',
  },
  welcomeSubtitle: {
    fontSize: '16px',
    color: '#666',
    margin: '0 0 24px 0',
  },
  badge: {
    display: 'inline-block',
    background: '#e8f4fd',
    color: '#0f3460',
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
  },
};

export default Dashboard;
